import { useState, useEffect } from 'react';

function useCities() {
  const [cities, setCities] = useState([]);
  const [citiesAll] = useState([]);

  useEffect(() => {
    const getCities = async () => {
      const response = await fetch('/api/bread/cities/search');
      const newCities = await response.json();
      if (response.status === 200) {
        setCities(newCities.results);

        for (let i = 0; i < newCities.results.length; i += 1) {
          citiesAll.push({
            value: newCities.results[i].id,
            label: newCities.results[i].name,
          });
        }
      }
    };
    getCities();
  }, []);
  return { cities, citiesAll };
}

export default useCities;
